import { stringify } from 'qs';
import { get, pick } from 'lodash/fp';
import {
  reservationsCreatePath,
  reservationsEditPath
} from '../../routes/Paths';
import pagePathToUrl from '../pagePathToUrl';

export const createLinkGuestUrl = ({ id, firstName, lastName }) => {
  const editUrl = pagePathToUrl(reservationsEditPath, { id });
  return `${editUrl}?linkGuest=1&firstName=${firstName}&lastName=${lastName}`;
};

export const createReservationUrl = reservation => {
  const { guestId, guest = {} } = reservation;
  const query = guestId
    ? {
        guestId,
        firstName: get('firstname', guest),
        lastName: get('lastname', guest),
        homeless: get('homeless', guest),
        streetAddress: get('street_address', guest),
        apartment: get('apartment', guest) || '',
        city: get('city', guest),
        state: get('state', guest),
        zipCode: get('zipcode', guest),
        homePhone: get('phone', guest) || '',
        workPhone: get('workphone', guest) || '',
        cellPhone: get('cellphone', guest) || '',
        email: get('email', guest) || '',
        householdTotal: get('household_total', guest)
      }
    : pick(
        [
          'guestId',
          'firstName',
          'lastName',
          'homeless',
          'streetAddress',
          'apartment',
          'city',
          'state',
          'zipCode',
          'homePhone',
          'workPhone',
          'cellPhone',
          'email',
          'householdTotal'
        ],
        reservation
      );

  return `${reservationsCreatePath}?${stringify(query)}`;
};

export const createVisitUrl = ({ id, outreachId, guestId = null }) =>
  guestId
    ? `/create-new-visit/setDate-outreach/${outreachId}/${guestId}`
    : `/create-new-visit/setDate-outreach/${outreachId}/rid:${id}`;
